import { createFileRoute } from "@tanstack/react-router";
import { ErrorPage } from "../../../features/errors";

export const Route = createFileRoute("/$lang/_layout/error/$status")({
  component: ErrorStatusRoute,
});

function ErrorStatusRoute() {
  const { status } = Route.useParams();
  return <ErrorPage status={Number(status)} />;
}
